/* ==============================================
   PARTY SIGNS — Theme JS
   ============================================== */

document.addEventListener('DOMContentLoaded', () => {

  // ---- Sticky header shadow ------------------
  const headerWrapper = document.querySelector('.header-wrapper');
  if (headerWrapper) {
    const onScroll = () => {
      headerWrapper.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- Mobile Nav ----------------------------
  const mobileToggle = document.getElementById('mobile-nav-toggle');
  const mobileNav    = document.getElementById('mobile-nav');
  const mobileOverlay = document.getElementById('mobile-overlay');
  const mobileClose  = document.getElementById('mobile-nav-close');

  function openMobileNav() {
    mobileNav && mobileNav.classList.add('is-open');
    mobileOverlay && mobileOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    mobileNav && mobileNav.classList.remove('is-open');
    mobileOverlay && mobileOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  mobileToggle  && mobileToggle.addEventListener('click', openMobileNav);
  mobileClose   && mobileClose.addEventListener('click', closeMobileNav);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobileNav);

  // Mobile sub-menu toggles
  document.querySelectorAll('.mobile-nav__item[data-has-sub]').forEach(item => {
    const link = item.querySelector('.mobile-nav__link');
    const sub  = item.querySelector('.mobile-sub');
    const toggle = item.querySelector('.mobile-nav__toggle');
    if (link && sub) {
      link.addEventListener('click', e => {
        if (toggle) { e.preventDefault(); }
        sub.classList.toggle('is-open');
        if (toggle) toggle.textContent = sub.classList.contains('is-open') ? '−' : '+';
      });
    }
  });

  // ---- Cart Drawer ---------------------------
  const cartOverlay = document.getElementById('cart-overlay');
  const cartDrawer  = document.getElementById('cart-drawer');
  const cartClose   = document.getElementById('cart-drawer-close');
  const cartToggle  = document.getElementById('cart-icon-btn');

  function openCart() {
    cartDrawer  && cartDrawer.classList.add('is-open');
    cartOverlay && cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    cartDrawer  && cartDrawer.removeAttribute('aria-hidden');
  }
  function closeCart() {
    cartDrawer  && cartDrawer.classList.remove('is-open');
    cartOverlay && cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    cartDrawer  && cartDrawer.setAttribute('aria-hidden', 'true');
  }
  cartToggle  && cartToggle.addEventListener('click', openCart);
  cartClose   && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  // Remove item from cart drawer
  document.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', async () => {
      const key = btn.dataset.key;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      location.reload();
    });
  });

  // Update cart count badge
  async function refreshCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.dataset.count = cart.item_count;
      });
    } catch(e) {}
  }
  refreshCartCount();

  // ---- Add to Cart ---------------------------
  const addToCartForm = document.querySelector('.product-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async e => {
      // If a file is attached, let the browser submit normally so Shopify handles the upload
      const fileInput = addToCartForm.querySelector('input[type="file"]');
      if (fileInput && fileInput.files && fileInput.files.length > 0) return;

      e.preventDefault();
      const btn = addToCartForm.querySelector('[type="submit"]');
      const origText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      const fd = new FormData(addToCartForm);
      try {
        await fetch('/cart/add.js', { method: 'POST', body: fd });
        await refreshCartCount();
        btn.textContent = 'Added!';
        setTimeout(() => { btn.textContent = origText; btn.disabled = false; }, 1500);
        openCart();
      } catch(err) {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
      }
    });
  }

  // ---- File Upload display -------------------
  document.querySelectorAll('.file-upload-input').forEach(input => {
    input.addEventListener('change', () => {
      const area = input.closest('.file-upload-area');
      const filenameEl = area.querySelector('.file-upload-filename');
      if (input.files && input.files[0]) {
        area.classList.add('has-file');
        if (filenameEl) {
          filenameEl.textContent = '✓ ' + input.files[0].name;
          filenameEl.classList.add('is-visible');
        }
      } else {
        area.classList.remove('has-file');
        if (filenameEl) filenameEl.classList.remove('is-visible');
      }
    });
  });

  // ---- Product Gallery -----------------------
  const galleryMain   = document.getElementById('gallery-main-img');
  const galleryThumbs = document.querySelectorAll('.product-gallery__thumb');
  const galleryCounter = document.getElementById('gallery-current');

  galleryThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src    = thumb.dataset.src;
      const srcset = thumb.dataset.srcset;
      const index  = thumb.dataset.index;
      if (galleryMain && src) {
        galleryMain.src = src;
        if (srcset) galleryMain.srcset = srcset;
        galleryThumbs.forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (galleryCounter && index) galleryCounter.textContent = index;
      }
    });
  });

  // ---- Share button --------------------------
  const shareBtn = document.getElementById('share-btn');
  if (shareBtn) {
    shareBtn.addEventListener('click', async () => {
      if (navigator.share) {
        try {
          await navigator.share({ title: document.title, url: location.href });
        } catch(e) {}
      } else {
        await navigator.clipboard.writeText(location.href);
        const orig = shareBtn.textContent;
        shareBtn.textContent = '✓ Link copied!';
        setTimeout(() => { shareBtn.innerHTML = '<svg viewBox="0 0 24 24"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg> Share'; }, 2000);
      }
    });
  }

  // ---- Quantity Selector ---------------------
  const qtyMinus = document.getElementById('qty-minus');
  const qtyPlus  = document.getElementById('qty-plus');
  const qtyInput = document.getElementById('quantity');

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value, 10);
      if (v > 1) qtyInput.value = v - 1;
    });
    qtyPlus.addEventListener('click', () => {
      const v = parseInt(qtyInput.value, 10);
      qtyInput.value = v + 1;
    });
  }

  // ---- Accordions ----------------------------
  document.querySelectorAll('.accordion-item__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content  = trigger.nextElementSibling;
      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      content && content.classList.toggle('is-open', !expanded);
    });
  });

  // ---- Search Modal --------------------------
  const searchToggle = document.getElementById('search-toggle');
  const searchModal  = document.getElementById('search-modal');
  const searchModalClose = document.getElementById('search-modal-close');
  const searchInput  = document.getElementById('search-input');

  searchToggle && searchToggle.addEventListener('click', () => {
    searchModal  && searchModal.classList.add('is-open');
    searchInput  && setTimeout(() => searchInput.focus(), 50);
  });
  searchModalClose && searchModalClose.addEventListener('click', () => {
    searchModal && searchModal.classList.remove('is-open');
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      searchModal && searchModal.classList.remove('is-open');
      closeCart();
      closeMobileNav();
    }
  });

  // ---- Cart quantity update -----------------
  document.querySelectorAll('.cart-qty-input').forEach(input => {
    input.addEventListener('change', async () => {
      const key = input.dataset.key;
      const qty = parseInt(input.value, 10);
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      location.reload();
    });
  });

});
